import React from 'react';

function ClockFastForward({ fill, ...restProps }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill ?? ''}
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M11.08 2.045A10.098 10.098 0 0 0 6.54 3.63a9.034 9.034 0 0 0-1.621 1.328 9.852 9.852 0 0 0-2.906 7.362c.071 2.119.739 4.008 2.02 5.72.397.53 1.272 1.424 1.767 1.807a10.156 10.156 0 0 0 4.8 2.059c.572.089 2.102.101 2.68.021 2.449-.34 4.754-1.583 6.277-3.385.372-.44.421-.542.421-.882 0-.329-.09-.534-.323-.739-.205-.18-.37-.241-.653-.241-.392 0-.493.064-1.096.699-.3.316-.685.687-.856.825-2.431 1.961-5.726 2.347-8.521.996a7.857 7.857 0 0 1-2.682-2.1c-1.745-2.086-2.296-4.987-1.444-7.598A8.137 8.137 0 0 1 7.62 5.309c1.998-1.316 4.579-1.656 6.878-.906a8.137 8.137 0 0 1 4.193 3.217c.654.992 1.127 2.3 1.251 3.46l.028.26-.339-.33c-.399-.386-.593-.488-.933-.489-.798-.003-1.27.887-.816 1.539.061.088.585.632 1.165 1.208 1.119 1.113 1.248 1.211 1.604 1.218.255.005.429-.043.609-.168.187-.131 2.17-2.121 2.291-2.299.117-.173.163-.474.111-.728-.146-.719-1-1.013-1.605-.552l-.126.097-.027-.227A10.175 10.175 0 0 0 19.847 5.8c-.337-.435-1.208-1.306-1.647-1.646-2.067-1.599-4.554-2.336-7.12-2.109m.615 4.012a1.04 1.04 0 0 0-.567.459l-.108.184-.012 2.7c-.009 1.929.001 2.746.033 2.86.1.353.177.416 1.878 1.552.891.596 1.684 1.106 1.761 1.134.337.121.755.021 1.021-.245.351-.351.391-.892.096-1.305-.047-.066-.688-.522-1.439-1.023l-1.356-.905-.011-2.384L12.98 6.7l-.108-.184a1.005 1.005 0 0 0-1.177-.459'
        fill-rule='evenodd'
        fill={fill ?? ''}
      />
    </svg>
  );
}

export default ClockFastForward;
